// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tile":"_33KGB","comingSoon":"_2Ggkp","iconContainer":"_10i-E","textWrapper":"_3P647","comingSoonText":"_3JFtA"};